import { formatDate } from './format';

/** Guide §7.1 — le dévoilage sans date se cale sur `dateSeance - 4 h`. */
const QUATRE_HEURES_MS = 4 * 60 * 60 * 1000;

/** Les seuls champs utiles : présents à la fois sur `Commande` et sur `CommandeSummary`. */
export interface EtatQrInput {
  envoiCodeBarreDiffere: boolean;
  dateAffichageCodeBarre: string | null;
  dateSeance: string;
}

/**
 * Ce que l'app affiche pour les QR codes maintenant (arbre de décision du guide §7.1, simplifié :
 * on ignore la branche « hors connexion », le BO ne peut pas la connaître).
 * `qrDelivres` = au moins un billet a un `numeroCodeBarre` non vide.
 * `now` doit être l'heure serveur (l'app lit l'en-tête `Date`, pas l'horloge du téléphone).
 */
export function etatQrCodes(commande: EtatQrInput, qrDelivres: boolean, now: Date): string {
  if (commande.envoiCodeBarreDiffere) {
    if (commande.dateAffichageCodeBarre) {
      const devoilage = new Date(commande.dateAffichageCodeBarre);
      if (!Number.isNaN(devoilage.getTime()) && now < devoilage) {
        return `QR codes masqués jusqu’au ${formatDate(commande.dateAffichageCodeBarre)}`;
      }
    } else {
      const seance = new Date(commande.dateSeance);
      if (!Number.isNaN(seance.getTime()) && now.getTime() < seance.getTime() - QUATRE_HEURES_MS) {
        return 'QR codes masqués jusqu’à séance − 4 h';
      }
    }
  }
  return qrDelivres ? 'QR codes visibles' : 'QR codes non délivrés';
}
